import { type DocumentWithUrl, Category } from '../types';
import { getDocument } from './stateGetters';
import { createToast } from './toasts.platform';
import copyTextToClipboard from './utils/copyTextToClipboard';

export default async (documentId: DocumentWithUrl['id']): Promise<void> => {
  const doc = await getDocument<DocumentWithUrl>(documentId);

  if (!doc) {
    return;
  }
  const isDistributable = Boolean(doc && !doc.non_distributable);
  if (!isDistributable) {
    createToast({ content: 'This action is not supported for this document', category: 'info' });
    return;
  }

  if (doc?.category === Category.Email) {
    createToast({ content: `Emails don't have urls, so sharing their URL is not possible.`, category: 'info' });
    return;
  }

  if (doc && doc.url) {
    copyTextToClipboard(doc.url, {
      successToastMessage: 'Copied URL to clipboard',
    });
  }
};
